<ion-header *ngIf="appearance === 'sidebar'" class="ion-no-border">
  <ion-item lines="full">
    <ion-label>
      <h6 class="bold">
        {{ participantName ? 'Stats for ' + participantName : 'Local Stats' }}
        <sc-learn-more topic="statsForNerds"></sc-learn-more>
      </h6>
    </ion-label>

    <ion-button aria-label="Close" (click)="closeSidebar.emit()" tooltip="Close">
      <ion-icon src="/assets/icons/24px/close.svg" slot="icon-only"> </ion-icon>
    </ion-button>
  </ion-item>
</ion-header>
<div class="scroll-container">
  <sc-upload-stats
    *ngIf="recordingActive"
    [recordingID]="recordingID"
    [screenID]="screenID"
    [details]="true"></sc-upload-stats>
  <div class="chart-container"><canvas #totalBitrateCanvas></canvas></div>
  <div class="chart-container square-chart" [hidden]="!hasAvailableBitrate"><canvas #availablePieCanvas></canvas></div>
  <div class="chart-container"><canvas #packetLossCanvas></canvas></div>
</div>
